import React from 'react';
import './Footer.css';
import linkedIn from '../../images/linkedIn.png';
import gitHub from '../../images/github.png';
import facebook from '../../images/facebook.png';

const Footer = () => {
        return (
                <div className="footer pb-3 pt-5">
                        <div className="container text-center"
                        >
                                <div
                                >
                                        <p className="text-white">Copyright © 2021 ||
                                                <span className="brand-color fw-bold"> abdullah-al-akash.netlify.app</span> </p>
                                        <small className="text-white">Maskanda, Mymensingh, Bangladesh</small>
                                        <p className="text-white">All Rights Reserved.</p>
                                </div>
                                <div

                                >
                                        <a href="https://www.linkedin.com/in/abdullahalakash/" target="_blank">
                                                <img className="single-icon" src={linkedIn} alt="" />
                                        </a>

                                        <a href="https://github.com/Abdullah-Al-Akash" target="_blank">
                                                <img className="single-icon" src={gitHub} alt="" />
                                        </a>

                                        <a href="https://web.facebook.com/abdullah.akash.al" target="_blank">
                                                <img className="single-icon" src={facebook} alt="" />
                                        </a>
                                </div>

                        </div>
                </div>
        );
};

export default Footer;